<app-mychart-web-header 
    [firstName]="patientFirstName">
</app-mychart-web-header>
<div *ngIf="isMobileResolution==false" class="search-background-web">
    <div class="search-container-web">
        <div class="search-title-web">
            {{title}}
        </div>
        <div *ngIf="searchMode=='provider'" class="search-sub-container-web">
            <div class="search-toggle-container-web">
                <button mat-button class="search-toggle-btn-selected-web" (click)="toggleSearchMode('provider')" >Provider</button>
                <button mat-button class="search-toggle-btn-unselected-web" (click)="toggleSearchMode('location')">Location</button>
            </div>
        </div>
        <div *ngIf="searchMode=='location'" class="search-sub-container-web">
            <div class="search-toggle-container-web">
                <button mat-button class="search-toggle-btn-unselected-web" (click)="toggleSearchMode('provider')" >Provider</button>
                <button mat-button class="search-toggle-btn-selected-web" (click)="toggleSearchMode('location')">Location</button>
            </div>
        </div>
        <div class="search-sub-container-web">
            <div class="search-results-container-web">
                <div *ngIf="searchMode=='provider'" class="search-results-web">
                    <div style="padding-right: 2rem;">
                        <app-provider-search-filter></app-provider-search-filter>    
                    </div>
                    <div style="flex: 1 1 auto; width: 100%; gap: 30px">
                        <app-provider-search-details></app-provider-search-details>
                        <br>
                        <app-provider-search-results></app-provider-search-results>
                    </div>
                </div>
                <div *ngIf="searchMode=='location'">
                    <app-location-search-results></app-location-search-results>
                </div>
            </div>
            <div class="custom-container-web"><br><br></div>
        </div>
    </div>
</div>